import React from "react"
import { ARTICLE_HEADER_POSITIONS } from "App/modules/articles/articles"

const HeaderPositioner = ({
  articleHeaderPosition,
  renderArticleTitle,
  renderArticleHeader
}) => {
  const POSITIONING_LAYOUT = {
    [ARTICLE_HEADER_POSITIONS.top]: () => (
      <>
        {renderArticleHeader()}
        {renderArticleTitle()}
      </>
    ),
    [ARTICLE_HEADER_POSITIONS.bottom]: () => (
      <>
        {renderArticleTitle()}
        {renderArticleHeader()}
      </>
    ),
  }

  return POSITIONING_LAYOUT[articleHeaderPosition]()
}

export default HeaderPositioner
